import { retryCancelablePromise } from '../core/utils/retryCancelablePromise';
export class CredentialsService {
    constructor(httpRequest) {
        Object.defineProperty(this, "httpRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: httpRequest
        });
    }
    /**
     * Create credential
     * Create credential.
     * @returns CredentialSchema Credential connection created successfully.
     * @throws ApiError
     */
    createCredential({ orgId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/orgs/{orgId}/credentials', path: {
                'orgId': orgId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get credentials
     * Get a credentials list (user-owned and shared).
     * @returns CredentialsList Successful credentials retrieval.
     * @throws ApiError
     */
    listCredentials({ orgId, after, before, limit = 10, filter, sort = '-id', search, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/credentials', path: {
                'orgId': orgId,
            }, query: {
                'after': after,
                'before': before,
                'limit': limit,
                'filter': filter,
                'sort': sort,
                'search': search,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Update credential
     * Update credential by ID.
     * @returns CredentialSchema Credential updated successfully.
     * @throws ApiError
     */
    updateCredential({ orgId, credentialId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PATCH', url: '/orgs/{orgId}/credentials/{credentialId}', path: {
                'orgId': orgId,
                'credentialId': credentialId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get credential
     * Get credential by id.
     * @returns CredentialSchema Successful GIT credential retrieval.
     * @throws ApiError
     */
    getCredential({ orgId, credentialId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/credentials/{credentialId}', path: {
                'orgId': orgId,
                'credentialId': credentialId,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Delete credential
     * Delete credential by ID.
     * @returns void
     * @throws ApiError
     */
    deleteCredential({ orgId, credentialId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'DELETE', url: '/orgs/{orgId}/credentials/{credentialId}', path: {
                'orgId': orgId,
                'credentialId': credentialId,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get credentials status
     * Returns credentials validity.
     * @returns CredentialStatus Connection status.
     * @throws ApiError
     */
    getCredentialStatus({ orgId, credentialId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/credentials/{credentialId}/status', path: {
                'orgId': orgId,
                'credentialId': credentialId,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
}
//# sourceMappingURL=CredentialsService.js.map